import { render, staticRenderFns } from "./ServiceClaim.vue?vue&type=template&id=9eb4db0a"
import script from "./ServiceClaim.vue?vue&type=script&lang=js"
export * from "./ServiceClaim.vue?vue&type=script&lang=js"
import style0 from "./ServiceClaim.vue?vue&type=style&index=0&id=9eb4db0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports